import { MultiSelectFilters } from './multiFilter.model';
import { ISelectOption } from '../../../selectOptions';
import { FilterTypesEnum } from '../../../filters/filterTypes.enum';

export class ActorTypeFilters extends MultiSelectFilters {
  constructor() {
    super(ActorTypeFilters.options);
  }

  public static readonly options: ISelectOption[] = [
    {
      id: 'API',
      value: 'API',
      displayName: 'API',
      categoryName: FilterTypesEnum.ActorType,
      filterType: FilterTypesEnum.ActorType,
    },
    {
      id: 'AUTH',
      value: 'AUTH',
      displayName: 'Auth',
      categoryName: FilterTypesEnum.ActorType,
      filterType: FilterTypesEnum.ActorType,
    },
    {
      id: 'PLAYBOOK',
      value: 'PLAYBOOK',
      displayName: 'Playbook',
      categoryName: FilterTypesEnum.ActorType,
      filterType: FilterTypesEnum.ActorType,
    },
    {
      id: 'UI',
      value: 'UI',
      displayName: 'UI',
      categoryName: FilterTypesEnum.ActorType,
      filterType: FilterTypesEnum.ActorType,
    },
  ];
}
